var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxsShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.937,
    height: 38.937,
    viewBox: "0 0 38.937 38.937",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bxs-ship",
    d: "M32.2,38.043a5.041,5.041,0,0,1-3.652-1.52,8.988,8.988,0,0,0-12.173,0,5.137,5.137,0,0,1-7.293,0A8.783,8.783,0,0,0,3,34.15v3.894a5.03,5.03,0,0,1,3.646,1.519,8.793,8.793,0,0,0,6.078,2.375,8.807,8.807,0,0,0,6.082-2.374,5.033,5.033,0,0,1,3.651-1.52,5.107,5.107,0,0,1,3.656,1.52,8.985,8.985,0,0,0,12.169,0,5.1,5.1,0,0,1,3.655-1.52V34.15a8.823,8.823,0,0,0-6.088,2.374A5.038,5.038,0,0,1,32.2,38.043ZM10.787,15.655l-3.894.973L10.787,32.2h1.936a8.807,8.807,0,0,0,6.082-2.374,5.033,5.033,0,0,1,3.651-1.52,5.107,5.107,0,0,1,3.656,1.52A8.809,8.809,0,0,0,32.2,32.2H34.15l.053-.209.61-2.437,3.23-12.928-3.894-.973V8.843a1.947,1.947,0,0,0-1.565-1.911L24.415,5.3V3H20.522V5.3L12.353,6.933a1.947,1.947,0,0,0-1.565,1.911Zm3.894-5.219,7.787-1.557,7.787,1.557v4.245l-7.787-1.947-7.787,1.947Z",
    transform: "translate(-3 -3)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxsShip);
export default __webpack_public_path__ + "static/media/bxs-ship.68158af249a38f96b94e331fd728d2ac.svg";
export { ForwardRef as ReactComponent };